import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import Popup from "../../../components/Popups/Popup";
import SpinnerOverlay from "../../../components/Spinner/SpinnerOverlay";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import ItemRevisionColorModel from "../../../models/ItemRevisionColorModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";

interface DeleteColorPopupProps extends PopupProps {
    onDelete(itemColorId: number)
    itemRevisionColor: ItemRevisionColorModel
}

const DeleteItemRevisionColorPopup: React.FC<DeleteColorPopupProps> = ({ show, onHide, onDelete, itemRevisionColor }) => {
    const [showSpinner, setShowSpinner] = useState(false);
    const { handleResult, handleException } = useNotifications();

    function submit() {
        setShowSpinner(true)
        DataService
            .delete(`api/v1/ItemRevisionColors/`, itemRevisionColor.id)
            .then(response => {
                setShowSpinner(false)
                handleResult(response, true);
                if (response.isSuccesful === true) {
                    onDelete(itemRevisionColor.id)
                    onHide()
                }
            })
            .catch(e => { setShowSpinner(false), handleException(e) });
    }

    return (
        <>
            <Popup show={show} onHide={onHide} size={'lg'} title={'Delete color'} >
                <Popup.Body>
                    <p><Translate>Are you sure you want to delete the color and connected subItem?</Translate></p>
                    {itemRevisionColor.alternativeName && <p> <Translate>Color: </Translate>{itemRevisionColor.alternativeName}</p>}
                </Popup.Body>
                <Popup.Footer>
                    <SaveButton onClick={submit} text='Delete' variant='danger' />
                </Popup.Footer>
            </Popup>
            {showSpinner && <SpinnerOverlay />}
        </>
    );
}
export default DeleteItemRevisionColorPopup;
